import {Box, Stack, Skeleton} from '@mui/material'

const SessionSkeleton = () => {
  return (
    <Box padding={2}>
      <Stack>
        {[...Array(6)].map((_, i) => (
          <Skeleton key={i} width={250} height={50} animation="wave" />
        ))}
      </Stack>
    </Box>
  )
}

export default SessionSkeleton
